import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'; // Link
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav,Form, Row} from 'react-bootstrap'; // Col 

import ModalWindow from '../../commons/helpers/modalWindow'; 
import Toast from '../../commons/helpers/toast';
import CustomMultiSelect from '../../commons/helpers/customMultiSelect';
import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { ROUTE_REFRESH, DELETE_SYMBOL,LOGIN_CLIENT_GROUP,LOGIN_AFFILIATE_GROUP, MASTER_RATE_CARD_ROWS } from '../../../configs/staticConfigs'; // LOGIN_AFFILIATE_GROUP, MSG_DATA_FETCH_CHIEF_BONUS_ERROR = "Failed to fetch Crew Chief data from the Server.";
import {  MSG_RATE_CARD_UPDATE_SUCCESS, MSG_RATE_CARD_UPDATE_ERROR, MSG_RATE_MISMATCH, MSG_ERROR,  MSG_DATA_FETCH_CHIEF_BONUS_ERROR, MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS, MSG_DATA_UPDATE_CHIEF_BONUS_ERROR, MSG_REQUIRED, MSG_CHIEF_CHARGE_RATE_ERROR, MSG_CONFIRM_DATA_CHANGE_RATE } from '../../../configs/msgConfigs'; // MSG_REQUIRED MSG_NOT_VALID_ERROR MSG_PAYRATE_REQUIRED MSG_CHARGERATE_REQUIRED
import { LBL_EDIT,LBL_COPY_RATE_TO_CATEGORY, LBL_APP_NAME, LBL_SETTINGS, LBL_SKILL, LBL_RATE_CARD, LBL_PAY_RATE, LBL_CHARGE_RATE, LBL_HOURS, LBL_BTN_ADDNEW, LBL_FOR, LBL_HRS_ABOVE, LBL_HOUR_SHORT, LBL_HOURS_SHORT, LBL_CONFIRM_DELETE_ROW, LBL_REMOVE_ROW, LBL_SAVE, LBL_BTN_ADD_STC, LBL_CREW_CHIEF, LBL_CREW_CHIEF_BONUS, LBL_CHIEF_PAY_RATE, LBL_CHIEF_CHARGE_RATE, LBL_COPY_RATES_TO,LBL_CONFIRM_DATA_CHANGE, LBL_CONFIRM_DELETE, LBL_CLIENT_CATEGORY,LBL_CLIENTS } from '../../../configs/labelConfigs';

import { clientProfileRateCardListAction, clientProfileRateCardUpdateAction,clientGetCrewChiefBonusAction,
    clientUpdateCrewChiefBonusAction, ClientListForCategories } from '../../../actions/clientActions'; 
import {clearAction} from '../../../actions/commonActions';
import { CLIENT_RATE_CARD_LIST_SUCCESS, CLIENT_RATE_CARD_LIST_ERROR, CLIENT_RATE_CARD_UPDATE_SUCCESS, CLIENT_RATE_CARD_UPDATE_ERROR, CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS, CLIENT_GET_CREW_CHIEF_BONUS_ERROR, CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS, CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR,CLIENT_LIST_FOR_CATEGORIES_SUCCESS } from '../../../actions'; 

import { decimalNumRegex, checkNumDot, checkNumDotZero} from '../../../utils/validation'; // formValid, 
import { changeColorBlue, changeColorNormal} from '../../../utils/displayFormats'; 
import {decimalTwo} from '../../../utils/commonUtilities'; 


import {format as stringFormat} from 'react-string-format';

// import NavbarCollapse from 'react-bootstrap/NavbarCollapse';

class RaateCard extends Component {

    constructor(props){
        super(props)

        this.state = {
            editData:false,    
            skillRatesAllData: [],  
            clientCategoryListData: [],  
            activeSkillRateData: { skill_id: 0, skill_name: '', rates_data: [] },    
            activeSkillId: 0,     
            deleteRowIndexNum: 0,                      
            formErrors:{
                fieldEmpty:'',
                crewChiefChargeRateLess: '',
                crewChiefPayRate: '',
                crewChiefChargeRate: ''                  
            },          
            clientId: this.props.clientId,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            activeSkillName:'',
            crewChiefPayRate: '0.00',
            crewChiefChargeRate: '0.00',
            isCrewChiefActive: 1,
            getCrewChiefBonusCalled: 0, 
            rateCardCalled: 0,
            skillMultiListAll:[],
            skillMultiList:[],
            rateCopyToSkills:[],
            reloadRateCard:0,
            refSkillId: 0,
            skillName: '',
            categoryIds:[],
            clientList:[],
            clientIds:[],
            clientIdError:false
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData   = this.saveFormData.bind(this);
        this.changeSkill = this.changeSkill.bind(this); 
        this.addNewRateRow = this.addNewRateRow.bind(this); 
        this.removeRow = this.removeRow.bind(this); 
        this.checkFormData = this.checkFormData.bind(this); 

        this.modalConfirm = React.createRef(); 
        this.modalDelete = React.createRef();
    }

    onCopyRateDataChange = (selectedData) =>{
        let selSkills = []; 
        selectedData.forEach((item) => {
            selSkills.push(item.value);
        });
        this.setState({ rateCopyToSkills:selSkills });        
    }
    enableEdit = (e)=>{
        e.preventDefault()
        this.setState({editData:true});
    }

    onClientCategoryChange = (selectedData) =>{
        let selCategories = []; 
        selectedData.forEach((item) => {
            selCategories.push(item.value);
        });
        this.setState({ categoryIds:selCategories,clientIdError:false }, () => {
            this.props.ClientListForCategories({selectedCategory:selCategories,clientId:this.props.clientId});
        });        
    }

    onClientListChange = (selectedData) =>{
        let selClients = []; 
        selectedData.forEach((item) => {
            selClients.push(item.value);
        });
        this.setState({ clientIds:selClients,clientIdError:false});
    }

    formatSkillData = (array) => {
        let skill = [];
        if(array.length>0){
            array.map(item => {
                let  skillObj = {};
                skillObj['value'] = item.id;
                skillObj['label'] = item.skill_name;
                skill.push(skillObj);
                return skill;
            });

        }
        return skill;
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        let affiliateId = 0;  
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_RATE_CARD;
            document.body.classList.add('body-affiliate'); 
            affiliateId = userGroupData.profile_id;
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client');
        }
     
        if(this.props.clientId && affiliateId){ 
            if(this.state.getCrewChiefBonusCalled===0) {
                this.props.clientGetCrewChiefBonusAction(this.props.clientId); 
            }
            if(this.state.rateCardCalled===0) {
                let tmpObj = {affiliateId:affiliateId, clientId:this.props.clientId}
                this.props.clientProfileRateCardListAction(tmpObj);   
            }
        }
    }  

    onModalFormReset = () =>{  
        this.setState({deleteRowIndexNum:0,formClick:false}); 
        if(this.state.skillName.length > 1) {
            this.changeSkillActive('',this.state.refSkillId,this.state.skillName); 
        }
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        let affiliateId = 0;  
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            affiliateId = userGroupData.profile_id;
        }
        if(this.props.clientId && affiliateId){ 
                this.props.clientGetCrewChiefBonusAction(this.props.clientId); 
                let tmpObj = {affiliateId:affiliateId, clientId:this.props.clientId}
                this.props.clientProfileRateCardListAction(tmpObj);   
        }

    }

    changeSkill = (event,refSkillId,skillName) => {
        if(this.state.formClick===true) {
            this.modalConfirm.current.handleOpenModal(); 
            this.setState({formClick:false,refSkillId:refSkillId,skillName:skillName}); 
        } 
        else {
            this.changeSkillActive(event,refSkillId,skillName); 
            this.setState({formClick:false,refSkillId:0,skillName:''}); 
        }
    }

    changeSkillActive = (event, refSkillId,skillName) => {
        
        if(skillName===LBL_CREW_CHIEF) {
            this.setState({editData:false,activeSkillId:refSkillId,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:skillName,isCrewChiefActive:1}); 
        }
        else if(this.state.activeSkillId!==refSkillId) {
            let allSkillRateObj = []; 
            let newActiveObj = {};
            this.state.skillRatesAllData.forEach((item,index) => {
                if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(this.state.activeSkillRateData); 
                else allSkillRateObj.push(item); 
                if(item.skill_id===refSkillId)  {
                    newActiveObj = item;                   
                }
            }); 

            // MODIFY THE MULTI SELECT SKILL DATA ALSO 
            let allSkills = this.state.skillMultiListAll;
            let multiSeldata = []; 
            multiSeldata = allSkills.filter(item => Number(item.value)!==Number(refSkillId)); 

            this.setState({editData:false,activeSkillId:refSkillId, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:skillName,isCrewChiefActive:0,skillMultiList:multiSeldata,rateCopyToSkills:[]}); 
        }   
    }

    disableSpace = (e)=>{
        if(e.which===32){
            e.preventDefault();
        }
    }

    onHandleChange = (e, rateIndex,fieldName) =>{
        e.preventDefault();
        // this.setState({formClick:true}); // to track form update without any value change in component did update 
        const {value}  = e.target;
        let formErrors      = this.state.formErrors;
        let activeData      = this.state.activeSkillRateData; 
        let valStr = value.trim(); 
        let finalIndex = 0;

        if(fieldName==='crewChiefPayRate') {  
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefPayRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : ""; 
            if(valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr && valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefPayRate:valStr, formErrors});  
        }     

        if(fieldName==='crewChiefChargeRate') { 
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefChargeRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : "";
            if(!checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefChargeRate:valStr, formErrors});  
        }

        let tmpRate = 0; 
        // activeSkillRateData rates_data  hours pay_rate charge_rate is_final 
        if(fieldName==='pay_rate') {
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  valStr = ''; // formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].pay_rate = valStr; 
            tmpRate = parseFloat(valStr); 
            // if(Number(rateIndex)===0) {
            //     finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
            //     activeData.rates_data[finalIndex].pay_rate = valStr; 
            // }
            if(tmpRate && Number(rateIndex)===(MASTER_RATE_CARD_ROWS-1)) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].pay_rate = parseFloat(tmpRate/MASTER_RATE_CARD_ROWS).toFixed(2); 
            }
            else if(Number(rateIndex)===0) {
                let newRateData = []; 
                activeData.rates_data.forEach(rateItem => {
                    if(rateItem.hours > 1 && !rateItem.is_final) {
                        rateItem.pay_rate = parseFloat(rateItem.hours*valStr).toFixed(2); 
                    }
                    else if(rateItem.is_final) {
                        rateItem.pay_rate = parseFloat(valStr).toFixed(2); 
                    }
                    newRateData.push(rateItem); 
                })
                activeData.rates_data = newRateData; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors}); 
        } 
        else if(fieldName==='charge_rate') { 
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  valStr = ''; // formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].charge_rate = valStr; 
            tmpRate = parseFloat(valStr); 
            // if(Number(rateIndex)===0) {
            //     finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
            //     activeData.rates_data[finalIndex].charge_rate = valStr; 
            // }
            if(tmpRate && Number(rateIndex)===(MASTER_RATE_CARD_ROWS-1)) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].charge_rate = parseFloat(tmpRate/MASTER_RATE_CARD_ROWS).toFixed(2); 
            }
            else if(Number(rateIndex)===0) {
                // finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                // activeData.rates_data[finalIndex].charge_rate = valStr; 
                let newRateData = []; 
                activeData.rates_data.forEach(rateItem => {
                    if(rateItem.hours > 1 && !rateItem.is_final) {
                        rateItem.charge_rate = parseFloat(rateItem.hours*valStr).toFixed(2); 
                    }
                    else if(rateItem.is_final) {
                        rateItem.charge_rate = parseFloat(valStr).toFixed(2); 
                    }
                    newRateData.push(rateItem); 
                })
                activeData.rates_data = newRateData; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors});  
        }
    } 

    addNewRateRowBKUP = (e,rateIndex) => {
        let newRateObj = [];
        let newItem = {};
        let rowAdded = 0; 
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(index<=rateIndex) newRateObj.push(item); 
            else {
                if(rowAdded===0) {
                    newItem = { hours: item.hours, pay_rate: 0, charge_rate: 0, is_final: false};
                    rowAdded++; 
                    newRateObj.push(newItem); 
                    newItem = { hours: (item.hours+1), pay_rate: item.pay_rate, charge_rate: item.charge_rate, is_final: item.is_final};
                    newRateObj.push(newItem); 
                }
                else {
                    newItem = { hours: (item.hours+1), pay_rate: item.pay_rate, charge_rate: item.charge_rate, is_final: item.is_final};
                    newRateObj.push(newItem); 
                }
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false }
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        this.setState({formClick:true,activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    addNewRateRow = (e) => {
        e.preventDefault(); 
        let newRateObj = [];
        let newItem = {};
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(item.is_final) {
                newItem = { hours: item.hours, pay_rate: parseFloat(0.00).toFixed(2), charge_rate: parseFloat(0.00).toFixed(2), is_final: false};
                newRateObj.push(newItem); 
                newItem = { hours: (item.hours+1), pay_rate: parseFloat(item.pay_rate).toFixed(2), charge_rate: parseFloat(item.charge_rate).toFixed(2), is_final: item.is_final};
                newRateObj.push(newItem); 
            }
            else {
                newRateObj.push(item); 
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false }
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 
        
        this.setState({formClick:true,activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    removeRow = (rateIndex) => {
        let newRateObj = [];
        let newItem = {};
        let rowRemoved = 0; 
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(index<rateIndex) newRateObj.push(item); 
            else {
                if(rowRemoved===0) {
                    rowRemoved++; 
                }
                else {
                    newItem = { hours: (item.hours-1), pay_rate: item.pay_rate, charge_rate: item.charge_rate, is_final: item.is_final};
                    newRateObj.push(newItem); 
                }
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false}
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        let frmErr = this.state.formErrors; 
        frmErr.fieldEmpty = ''; 
        this.setState({formErrors: frmErr, formClick:true, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 
    
    deleteBtnClick = (indexNum) =>{
        let pRate = this.state.activeSkillRateData.rates_data[indexNum].pay_rate; 
        let cRate = this.state.activeSkillRateData.rates_data[indexNum].charge_rate; 
        if( ((parseFloat(pRate) <= 0) || (pRate==='')) && (parseFloat(cRate) <= 0 || (cRate===''))) {
            this.setState({deleteRowIndexNum: indexNum}, () => this.removeRow(this.state.deleteRowIndexNum)); 
        }
        else {
            this.setState({deleteRowIndexNum: indexNum}, () => this.modalDelete.current.handleOpenModal()); 
        }
    }

    onDeleteAction = () =>{
        if(this.state.deleteRowIndexNum > 0) this.removeRow(this.state.deleteRowIndexNum);
        this.modalDelete.current.handleModelClose();              
    }

    checkFormData() {
        let foundError = 0; 
        let errMsg = this.state.formErrors; 
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(parseFloat(item.pay_rate)===0 || parseFloat(item.charge_rate)===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(item.pay_rate==='' || item.charge_rate==='' || item.pay_rate===0 || item.charge_rate===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.pay_rate)) {  // checkNumDot,
                foundError = 1; 
                // errMsg.fieldEmpty = MSG_PAYRATE_REQUIRED;
                // this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.charge_rate)) {  
                foundError = 1; 
                // errMsg.fieldEmpty = MSG_CHARGERATE_REQUIRED;
                // this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(parseFloat(item.pay_rate) > parseFloat(item.charge_rate)) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
        }); 
        if(foundError===0) {
            return true; 
        }
    }

    saveData = () => {
        if(this.state.isCrewChiefActive > 0) {
            this.saveChiefBonusData('');
        }
        else {
            this.saveFormData('');
        }
        this.modalConfirm.current.handleModelClose();  
    } 
  
    saveFormData = (e)=>{
        if(e) e.preventDefault();
        if(this.state.clientIds.length === 0 && this.state.categoryIds.length > 0){
            this.setState({clientIdError:true});
            return;
        } 
        if(this.checkFormData()) {
            let saveDataObj = {
                clientId : this.props.clientId,
                skill_id : this.state.activeSkillRateData.skill_id,
                skill_name : this.state.activeSkillRateData.skill_name,
                other_skills: this.state.rateCopyToSkills, 
                rates_data : this.state.activeSkillRateData.rates_data,
                clients : this.state.clientIds
            };
            this.props.clientProfileRateCardUpdateAction(saveDataObj);  
            this.setState({formClick:false});
        }
    }

    saveChiefBonusData = (e)=>{ 
        if(e) e.preventDefault(); 
        if(parseFloat(this.state.crewChiefPayRate) > parseFloat(this.state.crewChiefChargeRate)) {
            let formErrors = this.state.formErrors;
            let userGroupData = userGroupUrlCheck(window.location);
            let msg_toast = ''; 
            if(userGroupData!==undefined){
                msg_toast = stringFormat(MSG_CHIEF_CHARGE_RATE_ERROR,userGroupData.supervisor_name,userGroupData.supervisor_name);
            }   
            formErrors.crewChiefChargeRateLess  = msg_toast;   
            this.setState({formErrors}); 
        }
        else { 
            let saveDataObj = {
                clientId:this.props.clientId,
                client_crew_chief_bonus : this.state.crewChiefChargeRate,
                client_crew_chief_pay_bonus : this.state.crewChiefPayRate
            }; 
            this.props.clientUpdateCrewChiefBonusAction(saveDataObj);  
            this.setState({formClick:false});
        }
    }


    reloadRateDetails = () => {
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        let affiliateId = 0;  
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            affiliateId = userGroupData.profile_id;
        }
    
        if(affiliateId){ 
            this.props.clientGetCrewChiefBonusAction(this.props.clientId); 
            let tmpObj = {affiliateId:affiliateId, clientId:this.props.clientId}
            this.props.clientProfileRateCardListAction(tmpObj);   
        }
    }

    componentDidUpdate(prevProps) {      

        const { reloadRateCard } = this.props; 
        if(reloadRateCard && Number(reloadRateCard) > Number(this.state.reloadRateCard)) {
            this.setState({reloadRateCard:reloadRateCard}, () => {
                this.reloadRateDetails(); 
            })
        }

        if(this.state.skillRatesAllData.length===0 && this.props.clientId > 0) {
            let userGroupData = userGroupUrlCheck(window.location);
            let userGroup = ''; 
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
            }

            let affiliateId = 0;  
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                affiliateId = userGroupData.profile_id;
            }
        
            if(affiliateId){ 
                if(this.state.getCrewChiefBonusCalled===0) {
                    this.props.clientGetCrewChiefBonusAction(this.props.clientId); 
                }
                if(this.state.rateCardCalled===0) {
                    let tmpObj = {affiliateId:affiliateId, clientId:this.props.clientId}
                    this.props.clientProfileRateCardListAction(tmpObj);   
                }
            }
        }

        const { status, activity, clientStatus, clientProfActivity, clientActivity } = this.props;
        if(clientProfActivity && clientProfActivity!==prevProps.clientProfActivity ){
            var arrResp = clientProfActivity.split('~~'); 
            var actString = arrResp[0];
            if(actString === CLIENT_LIST_FOR_CATEGORIES_SUCCESS){
                let clientList = []
                let clientIds = []
                this.props.clientListCategoryWise.forEach((cObj) => {
                    clientList.push({ value:cObj.client_id, label:cObj.client_name, inputVal:1 });
                    clientIds.push(cObj.client_id);
                });
                this.setState({clientList:clientList,clientIds:clientIds});
            }
        }

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 
                

                if(actString===CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS){ 
                    if(this.props.hasOwnProperty('clientCrewCheifBonusData') && this.props.clientCrewCheifBonusData.hasOwnProperty('client_bonus_data')) {
                        this.setState({crewChiefChargeRate: parseFloat(this.props.clientCrewCheifBonusData.client_bonus_data.client_crew_chief_bonus).toFixed(2), crewChiefPayRate:parseFloat(this.props.clientCrewCheifBonusData.client_bonus_data.client_crew_chief_pay_bonus).toFixed(2),getCrewChiefBonusCalled:1}); 
                    }
                } 
                else if(actString===CLIENT_GET_CREW_CHIEF_BONUS_ERROR){ 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_DATA_FETCH_CHIEF_BONUS_ERROR,getCrewChiefBonusCalled:1});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }

                if(actString===CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS){
                    let msg_toast = '';  
                    let userGroupData = userGroupUrlCheck(window.location);
                    if(userGroupData!==undefined){ 
                        msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS,userGroupData.supervisor_name); 
                    } 
                    this.setState({toastSuccess:true, toastFlag:true, toastMessage:msg_toast});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                    this.setState({editData:false});
                }
                else if(actString===CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR){ 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_DATA_UPDATE_CHIEF_BONUS_ERROR});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }


                // CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR

                if(actString===CLIENT_RATE_CARD_LIST_SUCCESS){ 
                    this.setState({clientList:[]});
                    if(this.props.hasOwnProperty('skillRatesAllData')) {
                        if(this.props.skillRatesAllData.length===0) {
                            this.setState({skillRatesAllData: [],rateCardCalled:1}); 
                        }
                        else {
                            let userGroupData = userGroupUrlCheck(window.location);
                            let activeSkillName = '' 
                            if(userGroupData!==undefined){
                                activeSkillName = userGroupData.supervisor_name;
                            }
                            // let activeSkillName = LBL_CREW_CHIEF; // this.props.skillRatesAllData[0].skill_name;
                            let tmpObj = {};
                            let rateObj = [];
                            let skillMultiObj = []; 
                            // activeSkillRateData: { skill_id: 0, skill_name: '', rates_data: [] },  
                            let cnt = 0;
                            let allSkillsObj = []; 
                            let newRateObj = [];
                            this.props.skillRatesAllData.forEach((rObj) => { 
                                cnt++; 
                                // if(rObj.rates_data!==null)
                                newRateObj = [];
                                if(!Array.isArray(rObj.rates_data)) rObj.rates_data = []; 
                                if(rObj.rates_data && rObj.rates_data.length===0) {
                                    let i = 0;
                                    for(i=0; i<MASTER_RATE_CARD_ROWS; i++) {
                                        newRateObj.push({ hours: (i+1), pay_rate: parseFloat(0.00).toFixed(2), charge_rate: parseFloat(0.00).toFixed(2),is_final: false}); 
                                    }
                                    newRateObj.push({ hours: (i+1), pay_rate: parseFloat(0.00).toFixed(2), charge_rate: parseFloat(0.00).toFixed(2), is_final: true}); 
                                }
                                else { 
                                    rateObj =  rObj.rates_data; 
                                    newRateObj = [];
                                    let hourCnt = 0;
                                    let firstPayRate=0, firstChargeRate=0;  
                                    let lastPayRate=0, lastChargeRate=0; 
                                    rObj.rates_data.forEach(tmpItem => {
                                        if(!tmpItem.is_final) hourCnt = parseInt(tmpItem.hours,10); 
                                        if(hourCnt===1) {
                                            firstPayRate = parseFloat(tmpItem.pay_rate).toFixed(2); 
                                            firstChargeRate = parseFloat(tmpItem.charge_rate).toFixed(2);   
                                        }
                                        if((Number(tmpItem.hours) <=MASTER_RATE_CARD_ROWS && !tmpItem.is_final) || (Number(tmpItem.hours) > MASTER_RATE_CARD_ROWS && tmpItem.is_final)) {
                                            tmpItem.pay_rate = parseFloat(tmpItem.pay_rate).toFixed(2); 
                                            tmpItem.charge_rate = parseFloat(tmpItem.charge_rate).toFixed(2); 
                                            newRateObj.push(tmpItem); 
                                        }
                                    });

                                    // IF ROW < MASTER_RATE_CARD_ROWS, ADD THOSE ROWS TOO 
                                    if(hourCnt < MASTER_RATE_CARD_ROWS) {
                                        let i = 0;
                                        let lastPayRate=0, lastChargeRate=0; 
                                        for(i=(hourCnt+1); i<=MASTER_RATE_CARD_ROWS; i++) {
                                            lastPayRate     = parseFloat(firstPayRate*i).toFixed(2);
                                            lastChargeRate  = parseFloat(firstChargeRate*i).toFixed(2);
                                            newRateObj.push({ hours: i, pay_rate: lastPayRate, charge_rate: lastChargeRate, is_final: false}); 
                                        }
                                        // ADD THE FINAL ROW ALSO 
                                        newRateObj.push({ hours: (MASTER_RATE_CARD_ROWS+1), pay_rate: parseFloat(lastPayRate/MASTER_RATE_CARD_ROWS).toFixed(2), charge_rate: parseFloat(lastChargeRate/MASTER_RATE_CARD_ROWS).toFixed(2), is_final: true}); 
                                    }


                                }                   

                                tmpObj = {
                                    skill_id: rObj.skill_id,
                                    skill_name: rObj.skill_name, 
                                    rates_data: newRateObj,
                                    is_final: rObj.is_final
                                };

                                skillMultiObj.push({ value:rObj.skill_id, label:rObj.skill_name }); 
                               
                                allSkillsObj.push(tmpObj);
                            });
                                
                            let skillId = this.state.activeSkillId; 
                            let skillName = this.state.activeSkillName;
                            let clientCategoryListObj = [{value:'not_set', label:'Not Set'}]
                            if(this.props.clientCategoryBasicData.length > 0){
                                this.props.clientCategoryBasicData.forEach((cObj) => {
                                        clientCategoryListObj.push({ value:cObj.id, label:cObj.name });
                                });
                            }

                            this.setState({activeSkillId: 0, activeSkillRateData: {},clientCategoryListData:clientCategoryListObj, skillRatesAllData: allSkillsObj,activeSkillName:activeSkillName,rateCardCalled:1,skillMultiList:skillMultiObj,skillMultiListAll:skillMultiObj}, () => {
                                if(skillId > 0) {
                                    this.changeSkill('',skillId,skillName); 
                                }
                            }); 
                        }

                    } 
                    else { 
                        this.setState({skillRatesAllData: [],rateCardCalled:1}); 
                    }
                } 
                else if(actString===CLIENT_RATE_CARD_LIST_ERROR) { 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ERROR,rateCardCalled:1});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }
                else if(actString===CLIENT_RATE_CARD_UPDATE_SUCCESS){ 
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_RATE_CARD_UPDATE_SUCCESS});
                    // IF COPY RATE TO OTHER SKILLS SELECTED, THEN RELOAD THE RATES FROM SERVER  
                    let rateCopyToSkills = this.state.rateCopyToSkills; 
                    if(Array.isArray(rateCopyToSkills) && rateCopyToSkills.length > 0) { 
                        let userGroupData = userGroupUrlCheck(window.location);
                        let userGroup = ''; 
                        let affiliateId = 0; 
                        if(userGroupData!==undefined){
                            userGroup = userGroupData.user_group; 
                            affiliateId = userGroupData.profile_id;
                            if(this.props.clientId && affiliateId){ 
                                let tmpObj = {affiliateId:affiliateId, clientId:this.props.clientId}
                                this.props.clientProfileRateCardListAction(tmpObj);   
                            }
                        }
                    }
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                    this.setState({editData:false});
                }
                else if(actString===CLIENT_RATE_CARD_UPDATE_ERROR) { 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_RATE_CARD_UPDATE_ERROR}); 
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }  

            }
        }
        // else if (activity && activity !== prevProps.activity) {
            
        // }
    }
    

    render(){
      
        const { status } = this.props;
        const { editData } = this.state;
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        let isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false;
        let { toastMessage, toastFlag, toastSuccess, activeSkillRateData,activeSkillName,isCrewChiefActive,skillMultiList} = this.state;        
        if(!Array.isArray(activeSkillRateData.rates_data)) activeSkillRateData.rates_data = []; 


        let rateArray = [];
        if(activeSkillRateData.rates_data.length>0){
            rateArray = activeSkillRateData.rates_data;
        }

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        let userGroupData = userGroupUrlCheck(window.location);
        let profileCurrency = ''; 
        let lblChiefPayRate = ''; 
        let lblChiefChargeRate = ''; 
        let lblCrewChief = ''; 
        if(userGroupData!==undefined){
            profileCurrency = userGroupData.profile_currency; 
             lblChiefPayRate = stringFormat(LBL_CHIEF_PAY_RATE,userGroupData.supervisor_name); 
             lblChiefChargeRate = stringFormat(LBL_CHIEF_CHARGE_RATE,userGroupData.supervisor_name); 
             lblCrewChief = userGroupData.supervisor_name; 
        }
        let txtClass = 'input-num-80';
        let txtErrorClass = 'input-num-80'+' input-error';
        if(!this.state.editData){
            txtErrorClass = txtErrorClass+' btn-edit-disable';
            txtClass = txtClass+' btn-edit-disable';
        }
        
        return(
            <div className="form-group col-md-12">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="form-group">
                <   div className="box margin-top-12">
                    
                    <div className="tab-head">
                        {/* <div className="float-left"> <h6>&nbsp;{LBL_RATE_CARD}</h6></div>
                        <div className="float-right"> <button className="btn btn-primary launch-modal saveBtnMinWidth " onClick={(e) => this.addNewRateRow(e)} >{LBL_BTN_ADDNEW}</button></div> */}
                        <table className="width-100-percent">
                            <thead>
                                <tr className="text-bold">
                                     <th className="text-left ">
                                        <h6>  
                                           {/* {LBL_RATE_CARD} 
                                            {(companyName) && <span>&nbsp;{' > '}&nbsp;{companyName}</span>} 
                                            {activeSkillName!=='' && <span>&nbsp;{' > '}&nbsp;</span> }
                                            <span className="text-blue">{activeSkillName}</span>*/}
                                        </h6>
                                    </th> 
                                    <th className="text-right to-right">
                                        {/* {!isCrewChiefActive && <button className="btn btn-primary launch-modal saveBtnMinWidth hide " onClick={(e) => this.addNewRateRow(e)} >{LBL_BTN_ADD_STC}</button>} &nbsp;&nbsp; */}

                                        {!isCrewChiefActive && !isSuperAdmin && <div className="float-right to-right width-100-percent "><button className="btn btn-primary  saveBtnMinWidth" onClick={this.state.editData?this.saveFormData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT}</button></div> }

                                        {!isCrewChiefActive && this.state.formErrors.fieldEmpty.length > 1 && 
                                            <><div className="width-100-percent padding-top-35">
                                            <div className="text-red to-right text-right"><small>{this.state.formErrors.fieldEmpty}</small></div></div></>
                                        }
                                    </th>
                                </tr>
                            </thead> 
                        </table>
                    </div>
                    
                    <div>
                    <Form>
                    <Row>
                    <Tab.Container id="rateCard-tab" defaultActiveKey="rateCard-chief-rate-tab">
                    <div className="col-md-5 col-lg-4 col-xl-3 ">
                        <div className="box">
                            <div className="tab-head">
                            <div className="leftPanelHeading ">{LBL_SKILL}</div>
                            </div>
                        </div>
                        <Nav variant="pills" className="rate-card nav flex-column nav-pills box">

                            <Nav.Link eventKey="rateCard-chief-rate-tab" onClick={(e) => this.changeSkill(e, 0,LBL_CREW_CHIEF)}>
                                { (this.state.isCrewChiefActive===1) && 
                                <span className='spanPointer blueText ' > {lblCrewChief} </span> 
                                }
                                { (this.state.isCrewChiefActive!==1) && 
                                <span className='spanPointer normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, 0, LBL_CREW_CHIEF)} >  {lblCrewChief} </span>
                                }
                            </Nav.Link>

                            {this.state.hasOwnProperty('skillRatesAllData') && this.state.skillRatesAllData.map((item,index) => { 
                            return(
                                <Nav.Link eventKey="rateCard-details-tab" key={index} onClick={(e) => this.changeSkill(e, item.skill_id,item.skill_name)}>
                                    { (this.state.activeSkillId===item.skill_id) && 
                                    <span className='spanPointer blueText ' > {item.skill_name} </span> 
                                    }
                                    { (this.state.activeSkillId!==item.skill_id) && 
                                    <span className='spanPointer normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, item.skill_id)} >  {item.skill_name} </span>
                                    }
                                </Nav.Link>
                            ) } ) }
                        </Nav>
                    </div>
                    <div className="col-md-7 col-lg-8 col-xl-9 pl-0">
                        <Tab.Content> 

                            <Tab.Pane eventKey="rateCard-chief-rate-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{lblCrewChief}</h6></div>
                                        <div className="float-right paddingRight23">&nbsp;</div>
                                    </div>
                                    <div className="box-content">
                                        <div className="table-responsive">
                                            <table id="data-table" className='table col-12'  >
                                                <thead> 
                                                    <tr className="text-bold">
                                                        <th className="text-left">{lblChiefPayRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">{lblChiefChargeRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>    
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefPayRate" className={this.state.formErrors.crewChiefPayRate.length >0 ? txtErrorClass : txtClass} onChange={(e) => this.onHandleChange(e,0,'crewChiefPayRate')} value={this.state.crewChiefPayRate}  onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true}/></div>
                                                        </td>
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefChargeRate" className={this.state.formErrors.crewChiefChargeRate.length >0 ? txtErrorClass : txtClass} onChange={(e) => this.onHandleChange(e,0,'crewChiefChargeRate')} value={this.state.crewChiefChargeRate} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true} /></div>
                                                        </td>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>   
                                                    <tr> 
                                                        <td colSpan="4"> 
                                                            <div className="divFloatRight">
                                                                {this.state.formErrors.crewChiefChargeRateLess.length >=0 && <div className="text-red"><small>{this.state.formErrors.crewChiefChargeRateLess}</small></div>}
                                                                {!isSuperAdmin && <div className="divFloatRight"><button className="btn btn-primary launch-modal saveBtnMinWidth" onClick={this.state.editData?this.saveChiefBonusData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT} </button></div>}
                                                            </div>   
                                                        </td>
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>              
                                </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="rateCard-details-tab"> 
                                <div className="box"> 
                         
                                    <div className="tab-head">
                                    <div className="table-responsive">

                                        {this.state.hasOwnProperty('activeSkillRateData') && 
                                        <table id="data-table" className='table  width-100-percent'  >
                                            <thead>
                                            <tr className="text-bold">
                                                <th className="text-center">{LBL_HOURS}</th>

                                                <th className="text-left">{LBL_PAY_RATE+' ('+profileCurrency+')'}</th>

                                                <th className="text-left">{LBL_CHARGE_RATE+' ('+profileCurrency+')'}</th>
                                                
                                            </tr>
                                            </thead> 
                                            <tbody>
                                            
                                            {rateArray.map( (rateObj,rateIndex) => {  
                                         
                                            if(!rateObj.is_final) return( 
                                                <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                    <td className="text-center">{rateObj.hours}</td>

                                                    <td className="text-left"> 
                                                    <div className="form-group text-input"><input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0) || (this.state.activeSkillRateData.rates_data[rateIndex].pay_rate.trim()==='') ? txtErrorClass : txtClass}  name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true}/> 
                                                    {' '+LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)==1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()} </div> 
                                                    </td>

                                                    <td className="text-left"> <div className="form-group text-input"><input  className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) <= 0) || (parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) < parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate)) || (this.state.activeSkillRateData.rates_data[rateIndex].charge_rate.trim()==='') ? txtErrorClass : txtClass} name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'charge_rate')} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true}/> 
                                                    {' '+LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)==1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()} </div>
                                                    </td>

                                                    {/* <td className="text-center">{rateObj.hours > 1 && (activeSkillRateData.rates_data.length-1)===rateObj.hours && <i className={DELETE_SYMBOL} title={LBL_REMOVE_ROW} onClick={(e) => this.deleteBtnClick(rateIndex)} ></i>}</td>
                                                    <td className="text-left"> &nbsp; </td> */}
                                                </tr>
                                            ) 
                                            
                                            //     <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                            //     <td colSpan="11"> 
                                            //         {/* {this.state.formErrors.fieldEmpty.length >0 && ()}  */}
                                            //             <div className="text-red to-right text-small text-right">{this.state.formErrors.fieldEmpty}</div>
                                                    
                                            //         <div className="divFloatLeft">
                                            //             <div className="form-group text-input">
                                            //             For <span className="text-bold text-15">{this.state.activeSkillRateData.rates_data.length}</span> hrs and above, the <span className="text-bold text-15">Pay Rate </span>will be <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0) || (this.state.activeSkillRateData.rates_data[rateIndex].pay_rate.trim()==='') ? "input-error input-num-80" : 'input-num-80'} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} maxLength = {10}/> /hr and <span className="text-bold text-15">Charge Rate </span>will be <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) <= 0) || (this.state.activeSkillRateData.rates_data[rateIndex].charge_rate.trim()==='') ? txtErrorClass : 'txtClass'} name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e, rateIndex,'charge_rate')} maxLength = {10} disabled={this.state.editData?"":true}/> /hr </div> 
                                            //         </div> 
                                            //         <div className="divFloatRight"><button className="btn btn-primary  saveBtnMinWidth" onClick={this.saveFormData} > Save </button></div> 
                                                    
                                            //     </td>
                                            // </tr>
                                            // if(rateObj.is_final) return(
                                            // <tr><td colspan="7" className="text-right"> 
                                            //         <div className="text-red to-right text-small text-right">{this.state.formErrors.fieldEmpty}</div>
                                            //     </td>
                                            // </tr>
                                            // ) 
                                            if(rateObj.is_final) return(
                                            <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                <td className="text-center">
                                                    {LBL_FOR} <span className="text-bold text-15">{this.state.activeSkillRateData.rates_data.length}</span> {LBL_HRS_ABOVE} 
                                                </td>

                                                <td className="text-left"> 
                                                    <div className="form-group text-input">  
                                                    <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0) || (this.state.activeSkillRateData.rates_data[rateIndex].pay_rate.trim()==='') ? txtErrorClass : txtClass} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true}/> /{LBL_HOUR_SHORT.toLowerCase()}  </div> 
                                                </td>

                                                <td className="text-left">
                                                    <div className="form-group text-input">  
                                                    <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) <= 0) || (this.state.activeSkillRateData.rates_data[rateIndex].charge_rate.trim()==='') ? txtErrorClass : txtClass} name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e, rateIndex,'charge_rate')} onKeyPress={(e) =>this.disableSpace(e)} maxLength = {10} disabled={this.state.editData?"":true}/> /{LBL_HOUR_SHORT.toLowerCase()} </div> 
                                                </td>
                                            </tr>
                                            )
                                            return(console.log('.')); 
                                            }
                                        
                                            )}

                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.length > 0 && <><tr> 
                                                <td className="text-left"> <span className="marginLeft15">{stringFormat(LBL_COPY_RATES_TO,"'"+this.state.activeSkillName+"'")} </span></td>

                                                <td className="text-left" colSpan="2"> 
                                                    <div className="form-group multisel_textbox width300 text-12">
                                                        <div className="form-group select-input width300 text-12">
                                                            <CustomMultiSelect isDisable={this.state.editData?false:true} data={skillMultiList} initialText={'Select Skills'} onChange={selected =>this.onCopyRateDataChange(selected)} isTextBox={false} classValue="text-14-color width300" btnTextClass="text-14-color" />
                                                        </div> 
                                                    </div>
                                                </td>
                                            </tr>
                                            
                                            {/* 
                                            // COPY RATES TO CATEGORIES COMMENTED ON 25 Feb 2021 AS THIS FEATURE IS MOVED TO MASTER RATE CARD 
                                            
                                            <tr className="hide">
                                                <td className="text-left" colspan="3"><span className="marginLeft15">{LBL_COPY_RATE_TO_CATEGORY}</span></td>
                                            </tr>
                                            <tr className="hide">
                                                <td className="text-left"> <span className="marginLeft15">{LBL_CLIENT_CATEGORY}</span> </td>
                                                <td className="text-left" colSpan="2"> 
                                                    <div className="form-group multisel_textbox width300 text-12">
                                                        <div className="form-group select-input width300 text-12">
                                                            <CustomMultiSelect initialText={'Select Client Category'} data={this.state.clientCategoryListData}  onChange={selected =>this.onClientCategoryChange(selected)} isTextBox={false} classValue="text-14-color width300" btnTextClass="text-14-color" />
                                                        </div> 
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="hide">
                                                <td className="text-left"><span className="marginLeft15"> {LBL_CLIENTS}</span> </td>
                                                <td className="text-left" colSpan="2"> 
                                                    <div className="form-group multisel_textbox width300 text-12">
                                                        <div className="form-group select-input width300 text-12">
                                                            <CustomMultiSelect initialText={'Select Client'} data={this.state.clientList}  onChange={selected =>this.onClientListChange(selected)} isTextBox={false} classValue={this.state.clientIdError? "text-14-color width300 input-error": "text-14-color width300"} btnTextClass="text-14-color" />
                                                        </div> 
                                                    </div>
                                                </td>
                                            </tr> */}

                                            </>
                                            }
                                            {/* <td className="text-left">&nbsp; </td> */}

                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.length > 0 && <tr>
                                                <td colSpan="3" className="text-right width-100-percent">
                                                    {this.state.formErrors.fieldEmpty.length > 1 && 
                                                    <div className="text-red to-right text-right width-100-percent"><small>{this.state.formErrors.fieldEmpty}</small></div>}
                                                    <div className="divFloatRight">
                                                        <button className="btn btn-primary  saveBtnMinWidth" onClick={this.state.editData?this.saveFormData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT}</button>
                                                    </div> 
                                                </td>
                                            </tr>}
                                            
                                            </tbody>
                                        </table>
                                        }    
                                        </div>
                                    </div>    
                                </div>       
                            </Tab.Pane>
                        </Tab.Content>
                    </div>

                </Tab.Container>
                </Row>
                <div className="padding-top-50">&nbsp;</div>   
                <div className="padding-top-50">&nbsp;</div>   
                </Form>  
                        
                        
                    </div>
                </div>
            </div>       

                <ModalWindow ref={this.modalConfirm}  header={LBL_CONFIRM_DATA_CHANGE} type="save" saveFormData={this.saveData} resetModalForm={this.onModalFormReset}> {MSG_CONFIRM_DATA_CHANGE_RATE} </ModalWindow> 

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> {LBL_CONFIRM_DELETE_ROW} </ModalWindow>  
                {/* </Tab.Container>                */}
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    // console.log('clientCrewCheifBonusData:'+JSON.stringify(state.clientRateCard.clientCrewCheifBonusData)); 
    return {
        skillRatesAllData:state.clientRateCard.skillRateAllItems.data,
        status:state.clientRateCard.status,
        clientListCategoryWise:state.clients.clientListCategoryWise,
        clientProfActivity:state.clients.clientProfActivity,
        clientStatus:state.clients.status,
        clientActivity:state.clients.activity,
        activity:state.clientRateCard.activity,
        clientCrewCheifBonusData:state.clientRateCard.clientCrewCheifBonusData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        clientProfileRateCardListAction:clientProfileRateCardListAction,
        clientProfileRateCardUpdateAction:data=>clientProfileRateCardUpdateAction(data), 
        clientGetCrewChiefBonusAction:clientGetCrewChiefBonusAction,
        clientUpdateCrewChiefBonusAction: clientUpdateCrewChiefBonusAction, 
        ClientListForCategories: ClientListForCategories, 
        clearAction:clearAction
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(RaateCard);
